<template>
    <div class="order-details">
        <div v-if="order">
            <p class="order-details__status">
                <span>&nbsp;</span>
                <span>Bestelldatum: {{ date(order.processedAt) }}</span>
            </p>
            <table class="cart-table">
                <thead>
                    <tr>
                        <th>Produkte</th>
                        <th class="cart-table__price-header">Preis</th>
                        <th class="cart-table__quantity-header">Menge</th>
                        <th colspan="2">Total</th>
                    </tr>
                </thead>
                <tbody class="cart-table-tbody-desktop">
                    <tr class="cart-table-row--processing" v-for="(it, i) in orderItems" :key="i">
                        <td class="cart-table__thumbnail">
                            <div>
                                <span>
                                    <img :src="it.thumbnail" style="max-width:50px;max-height:50px" />
                                </span>
                                <span>
                                    {{ it.productName }}
                                    <span v-if="it.variant && it.variantName != 'Default Title'">({{ it.variantName }})</span>
                                </span>
                            </div>
                        </td>
                        <td class="cart-table__price-header">
                            {{ price(it.totalPrice / it.amount, 2) }}
                        </td>
                        <td class="cart-table__quantity-cell">
                            <p>{{ it.amount }}</p>
                        </td>
                        <td colspan="2">
                            {{ price(it.totalPrice, 2) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="no-orders" v-if="!loading && !order" style="background:#ffffff;padding:50px">
            <p>Order not found.</p>
            <router-link to="/account/orders">
                <button>Zur Bestellungsübersicht</button>
            </router-link>
        </div>
    </div>
</template>

<script>
    import { price, date } from "@/services/Formatters";

    export default {
        props: ["order"],
        inject: ["app"],
        data: () => ({
            orderItems: [],
            address: null,
            loading: true,
        }),
        mounted() {
            this.load();
        },
        methods: {
            price,
            date,
            load() {
                this.orderItems = this.order?.items || [];
                this.address = this.order.customer;
                this.loading = false;
            },
        }
    };
</script>

<style src="@/assets/scss/views/Order.scss" lang="scss"></style>
